import {SocialInsightList, SocialInsightRestControllerApiFactory, SocialConnectRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {FormButtonProps} from "../../../../components/form/form_inputs/form_button";
import dayjs from "dayjs";

export const SocialInsightListPage = () => {
    const apiManager = useApiManager();

    const collect = () => {
        const ctrl = apiManager.factory(SocialConnectRestControllerApiFactory);
        apiManager.execute(ctrl.collect()).then((res) => {
            const n = res?.["captured"] ?? 0;
            apiManager.enqueueSnackbar(`Métricas capturadas: ${n}`, {variant: "success"});
        });
    };

    const listConfig: AppListConfig<SocialInsightList> = {
        title: "Métricas sociales",
        onClick: "/app/admin/marketing/social-insight",
        actions: [
            {label: "Recolectar métricas", action: () => collect()} as FormButtonProps,
        ],
        headers: [
            {title: "Impresiones", align: "right"},
            {title: "Alcance", align: "right"},
            {title: "Me gusta", align: "right"},
            {title: "Comentarios", align: "right"},
            {title: "Compartidos", align: "right"},
            {title: "Interacciones", align: "right"},
            {title: "Capturado"},
        ],
        decorator: (bean: SocialInsightList) => (
            <>
                <TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>{bean.impressions?.toLocaleString("es-ES") ?? "—"}</TableCell>
                <TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>{bean.reach?.toLocaleString("es-ES") ?? "—"}</TableCell>
                <TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>{bean.likes?.toLocaleString("es-ES") ?? "—"}</TableCell>
                <TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>{bean.comments?.toLocaleString("es-ES") ?? "—"}</TableCell>
                <TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>{bean.shares?.toLocaleString("es-ES") ?? "—"}</TableCell>
                <TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>{bean.engagement?.toLocaleString("es-ES") ?? "—"}</TableCell>
                <TableCell>{bean.capturedAt ? dayjs(bean.capturedAt).format("DD/MM/YYYY HH:mm") : "-"}</TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(SocialInsightRestControllerApiFactory);
            return ctrl.pageSocialInsight(currentPage, size, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
